/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';

interface PushProviderConfigSaveBarSignature {
  Element: HTMLDivElement;
  Args: {
    platform: 'android' | 'ios';
    showDisablePushProviderButton: boolean;
    isEditing: boolean;
    isDirty: boolean;
    isInvalid: boolean;
    onReset: () => unknown;
    onSave: () => unknown;
    saveTooltipContent?: string;
    showSaveTooltip: boolean;
    onStartEditing?: () => unknown;
    onDisablePushProvider?: () => unknown;
  };
}

const PLATFORM_LABELS = {
  android: 'Android',
  ios: 'iOS',
};

export default class SaveBar extends Component<PushProviderConfigSaveBarSignature> {
  @service push!: PushService;

  get platformName() {
    let { platform } = this.args;
    return PLATFORM_LABELS[platform];
  }

  @action
  startEditing() {
    this.args.onStartEditing?.();
  }

  @action
  disablePushProvider() {
    this.args.onDisablePushProvider?.();
  }
}
